import { addToRecord } from '@ms/yammer-data-support';

import type { PublishersLoadStateFromIndexedDBAction } from '../../domains/publishers/loadStateFromIndexedDB.types';
import type { Publishers } from '../types';

type IndexedDBActionsReducer = (state: Publishers, action: PublishersLoadStateFromIndexedDBAction) => Publishers;
export const indexedDBActionsReducer: IndexedDBActionsReducer = (state, action) => {
  switch (action.type) {
    case 'PUBLISHER.LOAD_STATE_FROM_INDEXED_DB':
      return addToRecord(state, action.payload.publisher.id, action.payload.publisher);
    default:
      return state;
  }
};
